// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3IOhG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__jWX_h"};